import Marquee from "react-fast-marquee";
import { MARQUEE_WORDS } from "../../data";

export default function Ribbon() {
  return (
    <div
      className="relative border-y border-white/10 bg-ink py-6 md:py-8 overflow-hidden"
      data-testid="marquee-ribbon"
    >
      <Marquee speed={40} gradient={false} autoFill>
        {MARQUEE_WORDS.map((w, i) => (
          <span key={i} className="flex items-center">
            <span className="font-display uppercase tracking-tight text-4xl md:text-6xl text-stroke px-8">
              {w}
            </span>
            <span className="text-hotpink text-3xl md:text-5xl">✦</span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
